import { useEffect, useRef, useState } from "react";
import ReactDOM from 'react-dom';
import LatexHTMLRendererMemo from "../components/LatexHTMLRenderer/LatexHTMLRenderer";

export function useOffscreenLatexText(content: string): string {
  const [plainText, setPlainText] = useState('');
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!content) {
      setPlainText('');
      return;
    }

    const offscreenContainer = document.createElement('div');
    offscreenContainer.style.cssText = `
      position: absolute;
      top: -9999px;
      left: -9999px;
      visibility: hidden;
      pointer-events: none;
      width: 600px;
    `;
    document.body.appendChild(offscreenContainer);
    containerRef.current = offscreenContainer;

    const handleRenderComplete = () => {
      if (!containerRef.current) return;

      const clone = containerRef.current.cloneNode(true) as HTMLElement;
      // Drop both KaTeX renderings: the visual markup is unreadable and the
      // MathML carries a raw TeX annotation. The `.katex-sr` spans injected
      // alongside them (APAI-2402) supply the spoken form instead.
      clone.querySelectorAll('.katex-html, .katex-mathml').forEach(el => el.remove());

      setPlainText(clone.innerText?.trim() ?? '');
    };

    ReactDOM.render(
      <LatexHTMLRendererMemo
        content={content}
        onRenderComplete={handleRenderComplete}
      />,
      offscreenContainer
    );

    return () => {
      if (containerRef.current) {
        ReactDOM.unmountComponentAtNode(containerRef.current);
        containerRef.current.remove();
        containerRef.current = null;
      }
    };
  }, [content]);

  return plainText;
}